module.exports = __webpack_public_path__ + "static/media/ICC.77400fb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/ICC.svg
// module id = 75
// module chunks = 0